module.exports = __webpack_public_path__ + "assets/094bf79248e638d301342e74b259b3ea.png";